import { FormattedMessage } from 'react-intl'
import { CardMedia, Box, styled } from '@mui/material'
import { Button } from '@carto/meridian-ds/components'
import CardBase from 'features/common/ui/Cards/CardBase/CardBase'
import { MapEmptyCardProps } from 'features/maps/types'
import { AddCircleOutline } from '@mui/icons-material'
import useUserRoles from 'features/account/state/useUserRoles'

const Card = styled(CardBase)(() => ({
  position: 'relative',
  '& .MuiCardMedia-root': {
    height: '100%'
  }
}))

const Overlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'transparent',
  border: `solid ${theme.spacing(0.25)} transparent`,
  overflow: 'hidden',
  borderRadius: theme.spacing(1),
  transition: theme.transitions.create('border', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.standard
  }),
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.30)',
    cursor: 'pointer',
    border: `solid ${theme.spacing(0.25)} ${theme.palette.primary.main}`,
    '& > div': {
      display: 'flex'
    }
  },
  '& > div': {
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    fontSize: theme.spacing(1.5),
    color: theme.palette.primary.main,
    height: '100%',
    borderRadius: theme.spacing(1),
    border: `solid ${theme.spacing(0.75)} rgba(3, 111, 226, 0.12)`,
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard
    })
  }
}))

const ButtonWrapper = styled(Box)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate3d(-50%,-50%,0)',
  textAlign: 'center'
}))

function MapEmptyCard({ card, withButton }: { card: MapEmptyCardProps; withButton?: boolean }) {
  const { userHasEditionRole } = useUserRoles()

  const EmptyMapOverlay = () => {
    return (
      <Overlay>
        <Box>
          <AddCircleOutline fontSize="large" sx={{ mb: 1 }} />
          <FormattedMessage id="home.actions.map.new" />
        </Box>
      </Overlay>
    )
  }

  const EmptyMapButton = () => {
    return (
      <ButtonWrapper>
        <Button color="primary" variant="contained">
          <FormattedMessage id="home.actions.map.new" />
        </Button>
      </ButtonWrapper>
    )
  }

  return (
    <Card onClick={userHasEditionRole ? card.onClick : undefined} aria-label={'empty-map-label'}>
      <CardMedia image={card.img} title="title" component="img" />
      {userHasEditionRole && (withButton ? <EmptyMapButton /> : <EmptyMapOverlay />)}
    </Card>
  )
}

export default MapEmptyCard
